// extracted by mini-css-extract-plugin
export default {"button":"ButtonComponent_button__rBosF"};